type Callback = (...args: any[]) => void | Promise<void>;

const callbacks: { [key: string]: Callback[] } = {};

/**
 * 事件总线
 * @returns {
 *           $on: (eventName: string, callback: Callback) => void,
 *           $off: (eventName: string, callback: Callback) => void,
 *           $emit: (eventName: string, ...args: any[]) => void
 *          }
 */
export function useEventBus() {
  function $on(eventName: string, callback: Callback) {
    if (!callbacks[eventName]) {
      callbacks[eventName] = [];
    }
    callbacks[eventName].push(callback);
  }

  function $off(eventName: string, callback: Callback) {
    if (!callbacks[eventName]) return;
    callbacks[eventName] = callbacks[eventName].filter(cb => cb !== callback);
  }

  function $emit(eventName: string, ...args: any[]) {
    if (!callbacks[eventName]) return;
    callbacks[eventName].forEach((callback) => {
      callback(...args);
    });
  }

  function $clearAll() {
    // eslint-disable-next-line no-restricted-syntax
    for (const key in callbacks) {
      delete callbacks[key];
    }
  }

  function $unListen(eventName: string) {
    if (!callbacks[eventName]) return;
    delete callbacks[eventName];
  }

  function $onUnique(eventName: string, callback: Callback) {
    if (!callbacks[eventName]) {
      callbacks[eventName] = [];
    }
    if (!callbacks[eventName].includes(callback)) {
      callbacks[eventName].push(callback);
    }
  }

  function $onOnce(eventName: string, callback: Callback) {
    const onceCallback = (...args: any[]) => {
      callback(...args);
      $off(eventName, onceCallback);
    };
    $on(eventName, onceCallback);
  }

  return { $on, $off, $emit, $clearAll, $onUnique, $onOnce, $unListen };
}
